import React, { Component } from "react";
import { Row, Col, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { ImageContentLoader } from "../ContentLoader/ImageContentLoader";
import ImageUploadModal from "../Modals/ImageUploadModal";
import PlumProBox from "../Cards/PlumProBox";
import { makeRequestAuth, uploadRequest } from "../../utils/globals";
import ImageLoader from "../ImageLoader";
import {
  EmptyUpload,
  SelectedIcon,
  UploadIcon,
  IconCheveronRight,
  NoImageFound,
} from "../Icons";
import debounce from "lodash/debounce";
import _get from "lodash/get";
import {
  Input,
  Button,
  Icon,
  Modal,
  CircularLoader,
} from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";
import TemplateImageBox from "../Cards/TemplateImageBox";

const BottomBorderDiv = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.light.c300};
`;

const BottomTopDiv = styled.div`
  border-top: 1px solid ${(props) => props.theme.palette.light.c300};
`;

const UploadBannerDiv = styled.div`
  border: 1px dashed ${(props) => props.theme.palette.light.c300};
  padding: 40px;
  text-align: center;
`;

const SidebarDiv = styled.div`
  border-right: 1px solid ${(props) => props.theme.palette.light.c300};
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  width: 25%;
  .selected {
    background: ${(props) => props.theme.palette.light.c200};
    border-radius: 4px;
  }
`;
const MainDiv = styled.div`
  width: 75%;
  overflow: auto;
  height: calc(100vh - 100px);
  padding: 40px;
`;

const AlbumHeaderDiv = styled.div`
  &::after {
    content: "";
    display: inline-block;
    height: 0.5em;
    vertical-align: bottom;
    width: 89%;
    margin-right: -100%;
    margin-left: 10px;
    border-top: 1px solid ${(props) => props.theme.palette.light.c300};
    transform: translateY(-0.1rem);
  }
`;

const StyledIcon = styled(Icon).attrs()`
  background: ${(props) => props.theme.palette.background.tertiary};
  border-radius: 50%;
  padding: 14px;
`;

const ImageBoxDiv = styled.div`
  background: ${(props) => props.theme.palette.light.c100};
  padding: 24px;
  width: 80%;
  margin: auto;
`;
export default class TemplateModal extends Component {
  state = {
    showModal: true,
    uploading: false,
    selectedImage: {},
    imageUploadModal: false,
    selectedFile: true,
    searchtext: "",
    cardRenderImages: [],
  };

  componentDidMount() {
    this.getSelection();
  }

  getSelection = () => {
    const { selectedTemplate, cardImages } = this.props;
    this.setState({ cardRenderImages: cardImages });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.cardImages != this.props.cardImages) {
      this.setState({ cardRenderImages: this.props.cardImages });
      if (prevProps.cardImages.length < this.props.cardImages.length) {
        const latestImage = this.props.cardImages[0];
        if (latestImage && !latestImage.selected) {
          this.handleSelection(latestImage);
        }
      }
    }
  }

  uploadTemplateImages = (imgResp) => {
    if (imgResp == "") {
      this.setState({ errorMessage: "Please Select File" });
      return setTimeout(
        function () {
          this.setState({ errorMessage: "" });
        }.bind(this),
        2000
      );
    }
    if (imgResp[0].size > 300000) {
      this.setState({
        errorMessage: "Image size should be less than 300Kb.",
        errorMessageClass: "danger",
      });
      return setTimeout(
        function () {
          this.setState({ errorMessage: "", errorMessageClass: "" });
        }.bind(this),
        3000
      );
    }
    this.setState({ uploading: true });
    const formData = new FormData();
    formData.append("attachments", imgResp[0]);
    // formData.append('company_id',15)
    formData.append("site_id", this.props.site_id);
    uploadRequest(
      formData,
      function (response) {
        if (
          response !== undefined &&
          response.error == false &&
          response.data[0]
        ) {
          this.setState({
            fileErr: "",
            imageUploadModal: false,
            uploading: false,
          });
          // response.data[0].image_id
          // this.props.getCardImages()
          // this.props.getCardImages({"category_id": 5000,"category_name": "My uploads"})
          this.props.handleCategory();
          //this.handleCardSelect(response.data[0])
          NotificationManager.success(
            "Image uploaded successfully.",
            "success"
          );
        } else {
          NotificationManager.error(
            "Sorry, we could not upload this file. Try saving it in a different format and upload again",
            "Error"
          );
          this.setState({
            errorMsg:
              "Sorry, we could not upload this file. Try saving it in a different format and upload again",
            imageUploadModal: false,
            uploading: false,
          });
        }
        this.resetImage();
      }.bind(this),
      "/api/graph/uploadTemplateImages"
    );

    // this.setState({uploading:false})
  };

  handleModal = () => {
    this.setState({
      showModal: false,
    });
    this.props.callbackMethod ? this.props.callbackMethod() : null;
  };

  toggleImageUplaodModal = () => {
    this.setState({
      imageUploadModal: false,
    });
  };

  handleSelection = (index) => {
    const { cardImages, selectedCategory } = this.props;
    // debugger
    let selectedImage = {};
    // selectedImage = cardImages.filter(ele => ele.image_id === index.image_id)
    cardImages.map((ele, i) => {
      if (ele.image_id === index.image_id) {
        ele.selected = true;
        selectedImage = ele;
        selectedImage.selectedCategory = selectedCategory;
      } else {
        ele.selected = false;
      }
    });
    this.setState({ selectedImage, selectedFile: false });
  };

  handleSubmit = () => {
    const { selectedImage } = this.state;
    if (!selectedImage) {
      NotificationManager.error("Please Select An Image.", "Error");
    } else {
      this.props.updateState({ loader: true });
      this.props.callbackMethod ? this.props.callbackMethod() : null;
      this.props.updateState({
        selectedTemplate: selectedImage,
        loader: false,
      });
    }
  };

  handleUploadImage = (uploadModal = true) => {
    if (uploadModal) {
      this.setState({ imageUploadModal: true });
    }
    this.props.handleCategory({
      category_id: 5000,
      category_name: "My uploads",
    });
  };

  debounceSearchByAlbumName = debounce((searchtext) => {
    this.props.onSearch(searchtext);
  }, 500);

  handleSearch = (e) => {
    this.debounceSearchByAlbumName(e.target.value);
    this.setState({ searchtext: e.target.value });
  };

  handleDelete = (e, img_id) => {
    e.stopPropagation();
    this.props.deleteCardImage(img_id);
  };

  renderAlbumList = (cardImages) => {
    return cardImages.map((item, i) => {
      let cardClassName = item.selected
        ? "voucher-card-campaign banner-card "
        : "voucher-card-campaign banner-card";
      return (
        <Col
          key={i}
          xs="3"
          className=" mb-16 ml-0 card-link"
          onClick={() => this.handleSelection(item)}
        >
          <TemplateImageBox
            classname={cardClassName + " emailTemplate"}
            emailTemplate
            voucherUrl={item.image_url}
            isDelete={item.isDelete}
            company_id={item.company_id}
            imageId={item.image_id}
            deleteCardImage={this.handleDelete}
            name={item.image_name.split(".")[0]}
            cardId={i}
            bgImageClass={"banner-card-img"}
            cardTextClass={item.selected ? "card-text-selected mb-2" : "mb-2"}
            isSelectedImage={item.selected}
            isEdit={true}
            isEditListing={true}
          />
        </Col>
      );
    });
  };

  renderCategoryList = () => {
    const { categoryList, selectedCategory } = this.props;
    return categoryList.map((item, index) => {
      let selectedClass =
        selectedCategory.category_id === item.category_id ? "selected" : "";
      return (
        <div
          style={{ cursor: "pointer", padding: "2px 8px", margin: "2px 0" }}
          className={`${selectedClass} mt-16`}
          key={index}
          onClick={() => {
            this.setState({ searchtext: "" });
            this.props.handleCategory(item);
          }}
        >
          <div className="d-flex justify-content-between mb-0 py-8 pl-8">
            <Typography color="dark" shade="c300" className="m-0">
              {item.category_name}
            </Typography>
            {selectedClass ? (
              <span>
                <Icon
                  iconName="RightArrow"
                  color="dark"
                  shade="c300"
                  size={"16"}
                />
              </span>
            ) : null}
          </div>
        </div>
      );
    });
  };

  renderCardImages = () => {
    const { cardImages, selectedCategory } = this.props;
    const { cardRenderImages } = this.state;
    if (cardRenderImages.length === 0) {
      return this.renderNoImageFound();
    } else {
      cardRenderImages.sort((a, b) =>
        a.album_name > b.album_name ? 1 : b.album_name > a.album_name ? -1 : 0
      );
      let images = cardRenderImages.reduce((r, a) => {
        r[a.album_name] = [...(r[a.album_name] || []), a];
        return r;
      }, {});
      return Object.keys(images).map((ele, idx) => (
        <div className="row" key={idx}>
          <div className="col-12">
            <AlbumHeaderDiv className="medium inkNormal ablum-header mb-16">
              <Typography.LabelText
                component="span"
                color="dark"
                shade="c300"
              >{`${ele} (${images[ele].length})`}</Typography.LabelText>
            </AlbumHeaderDiv>
            <div className="row">{this.renderAlbumList(images[ele])}</div>
          </div>
        </div>
      ));
    }
  };

  renderUploadedImage = () => {
    const { cardImages, selectedCategory } = this.props;
    if (
      selectedCategory &&
      selectedCategory.category_id === 5000 &&
      cardImages.length === 0
    ) {
      return this.renderUploadNewBanner();
    }
    let images = cardImages.reduce((r, a) => {
      if (!_get(a, ["date"], null)) return r;
      r[a.date.substring(2)] = [...(r[a.date.substring(2)] || []), a];
      return r;
    }, {});
    return Object.keys(images).map((ele, idx) => (
      <div className="row" key={idx}>
        <div className="col-12">
          <AlbumHeaderDiv className="medium inkNormal ablum-header mb-16">
            <Typography.LabelText
              component="span"
              color="dark"
              shade="c300"
            >{`${ele} (${images[ele].length})`}</Typography.LabelText>
          </AlbumHeaderDiv>
          <div className="row">{this.renderAlbumList(images[ele])}</div>
        </div>
      </div>
    ));
  };

  renderNoUploadedImage = () => {
    return (
      <Row>
        <Col className="text-center mt-5 py-5">
          <EmptyUpload />
          <p className="mb-0 mt-5 medium">
            Welcome to your uploads! Please upload a new banner
          </p>
          <p className="mt-2 inkNormal">
            The recommended size for the banner image is 1200x600 pixels, with a
            maximum length of 300KB. You can upload either a .jpg or .jpeg file.
          </p>
          <Button
            style={{ cursor: "pointer" }}
            onClick={() => this.handleUploadImage(true)}
          >
            Upload
          </Button>
        </Col>
      </Row>
    );
  };

  renderNoImageFound = () => {
    return (
      <Row>
        <Col className="text-center mt-5 py-5">
          <NoImageFound />
          <p className="mb-0 mt-5 medium">Sorry, no results found!</p>
          <p className="mb-0 mt-2 inkNormal">You can upload your own image</p>
          <p className="mt-2 inkNormal">
            The recommended size for the banner image is 1200x600 pixels, with a
            maximum length of 300KB. You can upload either a .jpg or .jpeg file.
          </p>
          <Button
            color=" text-center"
            className="btn-outline-secondary-2"
            style={{ cursor: "pointer" }}
            onClick={this.handleUploadImage}
          >
            Upload
          </Button>
        </Col>
      </Row>
    );
  };

  uploadFile = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          image: e.target.result,
        });
      };
      reader.readAsDataURL(event.target.files[0]);
      this.setState({
        imgagename: event.target.files[0].name.split(" ").join("_"),
        imgUpload: event.target.files,
      });
    } else {
      NotificationManager.info(
        "Image size should be less than 300Kb",
        "Warning"
      );
    }
  };

  resetImage = () => {
    this.setState({
      image: "",
      imgagename: "",
      imgUpload: "",
    });
  };

  renderUploadNewBanner = () => {
    return (
      <>
        <UploadBannerDiv>
          {this.state.image ? (
            <div>
              <div>
                <Typography color="dark" shade="c200" className="mb-20">
                  Save your uploaded image to use it in the reward email.
                </Typography>
              </div>
              <ImageBoxDiv className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <img src={this.state.image} width="70" height="33" />
                  <Typography.HelperText className="ml-16">
                    {this.state.imgagename}
                  </Typography.HelperText>
                </div>
                <div>
                  <Button variant="plain" onClick={this.resetImage}>
                    Remove
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() =>
                      this.uploadTemplateImages(this.state.imgUpload)
                    }
                  >
                    Save
                  </Button>
                </div>
              </ImageBoxDiv>
            </div>
          ) : (
            <div>
              <input
                accept=".jpg, .jpeg"
                className="file d-none"
                id="contained-button-file"
                type="file"
                onChange={this.uploadFile}
              />
              <label
                htmlFor="contained-button-file"
                className="m-0 cursor-pointer"
              >
                <StyledIcon
                  iconName="PlumBulkUpload"
                  color="primary"
                  shade="c02"
                />

                <div className="my-12">
                  <Typography
                    className="cursor-pointer m-0"
                    color="blue"
                    shade="c200"
                  >
                    Click to upload
                  </Typography>
                </div>
              </label>
              <div>
                <Typography color="dark" shade="c200" className="mb-0">
                  We recommend using an image size of 1200x600 pixels. The
                  maximum file size is 300KB, and you can upload files in the
                  following formats: .jpg or .jpeg
                </Typography>
              </div>
            </div>
          )}
          {this.state.errorMessage ? (
            <div className="d-flex mt-24 align-items-center justify-content-center">
              <Icon iconName="PlumWarning" color="red" shade="c200" />
              <Typography className="mb-0 ml-12" color="red" shade="c200">
                {this.state.errorMessage}
              </Typography>
            </div>
          ) : null}
        </UploadBannerDiv>
        {/* <Row
        className="album-upload-section py-3 mb-3"
        style={{ height: "auto" }}
      >
        <Col xs="9">
          <h5>Upload new banner</h5>
          <p className="my-0">
            Recommended: 1200x600px. Maximum size: 300KB. Format: JPG/JPEG
          </p>
        </Col>
        <Col xs="3">
          <Button
            color="text-center"
            className="btn-outline-secondary-2 float-right"
            style={{ cursor: "pointer" }}
            onClick={this.handleUploadImage}
          >
            Upload
          </Button>
        </Col>
      </Row> */}
      </>
    );
  };

  renderSearchImages = () => {
    const { searchtext } = this.state;
    return (
      <Input
        type="search"
        onChange={(e) => {
          this.handleSearch(e);
        }}
        startIcon={<Icon iconName="Search" size={16} />}
        value={searchtext}
        placeholder="Search banner images"
      />
    );
  };

  render() {
    const {
      showModal,
      imageUploadModal,
      uploading,
      selectedFile,
      selectedImage,
      cardRenderImages,
    } = this.state;
    const { loader, selectedCategory } = this.props;
    // console.log("this.props",this.props)
    // console.log("state",this.state)
    const selectedClass =
      selectedCategory.category_id == 5000 ? "selected" : "";
    return (
      <>
        {imageUploadModal ? (
          <ImageUploadModal
            btnText="Upload"
            uploading={uploading}
            errorMessage={this.state.errorMessage}
            msgClass={this.state.errorMessageClass}
            uploadImage={this.uploadTemplateImages}
            imageRestriction="Image Size Should be less than 300Kb."
            header="Upload Image"
            callbackMethod={() => {
              this.toggleImageUplaodModal();
            }}
          />
        ) : (
          <Modal
            isOpen={showModal}
            fullScreen={true}
            className="banner-modal p-0"
          >
            <BottomBorderDiv className="d-flex justify-content-between py-24 px-40">
              <div>
                <Typography.H2>Edit Banner Image</Typography.H2>
                <Typography className="m-0">
                  Choose an image to replace the email banner. This banner image
                  will be standard for all recipients receiving the reward.
                </Typography>
              </div>
              <div>
                <Button
                  variant="plain"
                  className="mr-20"
                  onClick={this.handleModal}
                >
                  Cancel
                </Button>
                <Button
                  disabled={
                    selectedImage && selectedImage.image_id ? false : true
                  }
                  onClick={this.handleSubmit}
                >
                  Save
                </Button>
              </div>
            </BottomBorderDiv>
            <div className="d-flex">
              <SidebarDiv className="sideBar p-0 justify-content-between">
                <div className="px-40 pt-24">
                  <div>{this.renderSearchImages()}</div>
                  <div>
                    <Typography.HelperText
                      color="dark"
                      shade="c200"
                      className="mt-20 mb-8"
                    >
                      Categories
                    </Typography.HelperText>
                    {this.renderCategoryList()}
                  </div>
                </div>
                <BottomTopDiv
                  className={`${selectedClass} py-24 px-40 cursor-pointer`}
                  onClick={() => {
                    this.handleUploadImage(false);
                  }}
                >
                  <div className="d-flex justify-content-between mb-0">
                    <div className="d-flex">
                      <span className="mr-8">
                        <UploadIcon />
                      </span>
                      <Typography
                        color="dark"
                        className="d-flex align-items-center m-0"
                        shade="c300"
                      >
                        My uploads
                      </Typography>
                    </div>
                    {selectedClass ? (
                      <div>
                        <Icon iconName="RightArrow" color="dark" shade="c300" />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </BottomTopDiv>
              </SidebarDiv>
              <MainDiv>
                {loader || (selectedClass && cardRenderImages.length === 0)
                  ? null
                  : selectedClass
                  ? this.renderUploadNewBanner()
                  : null}
                {loader ? (
                  <div>
                    <div
                      className="d-flex flex-column justify-content-center"
                      style={{ height: "70vh" }}
                    >
                      <CircularLoader />
                    </div>
                  </div>
                ) : selectedClass ? (
                  <>
                    <Typography.H2 className="my-16" color="dark" shade="c300">
                      My Uploads
                    </Typography.H2>
                    {this.renderUploadedImage()}
                  </>
                ) : (
                  this.renderCardImages()
                )}
              </MainDiv>
            </div>
            {/* <div className="py-0 pl-3">
              <Row className="templateModal">
                <Col xs="3" className="sideBar p-0 justify-content-between">

                  <div className="px-3 py-4">
                    {this.renderSearchImages()}
                    <p className="inkLight mt-4 mb-2 fw-500 fs-12">
                      CATEGORIES
                    </p>
                    {this.renderCategoryList()}
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      borderTop: "1px solid #EEEEEE",
                      padding: "24px",
                    }}
                    className={selectedClass}
                    onClick={() => {
                      this.handleUploadImage(false);
                    }}
                  >
                    <p className="medium mb-0">
                      <span className="mr-2">
                        <UploadIcon />
                      </span>
                      My uploads
                      {selectedClass ? (
                        <span className="float-right">
                          <IconCheveronRight />
                        </span>
                      ) : (
                        ""
                      )}
                    </p>
                  </div>
                </Col>
                <Col xs="9" className="content my-0 py-4">
                  {loader || (selectedClass && cardRenderImages.length === 0)
                    ? null
                    : selectedClass
                    ? this.renderUploadNewBanner()
                    : null}
                  {loader ? (
                    <Row>
                      <Col
                        xs="12"
                        className="d-flex flex-column justify-content-center"
                        style={{ height: "70vh" }}
                      >
                        <ImageLoader />
                      </Col>
                    </Row>
                  ) : selectedClass ? (
                    this.renderUploadedImage()
                  ) : (
                    this.renderCardImages()
                  )}
                </Col>
              </Row>
            </div> */}
            {/* <div className="actionModalFooterRight d-block">
              <Row>
                <Col xs="9" className="text-left">
                  {selectedImage &&
                  selectedImage.image_id &&
                  selectedImage.selectedCategory ? (
                    <p className="medium my-2">
                      <SelectedIcon /> &nbsp;
                      <span>
                        {selectedImage.selectedCategory &&
                          selectedImage.selectedCategory.category_name}
                      </span>{" "}
                      -<span>&nbsp;{selectedImage.album_name}</span> -
                      <span>
                        &nbsp;{selectedImage.image_name.split(".")[0]}
                      </span>{" "}
                      is selected
                    </p>
                  ) : null}
                </Col>
                <Col xs="3" className="text-right">
                  <Button color="" onClick={this.handleModal}>
                    Cancel
                  </Button>
                  <Button
                    disabled={
                      selectedImage && selectedImage.image_id ? false : true
                    }
                    color="primary"
                    onClick={this.handleSubmit}
                  >
                    Use Image
                  </Button>
                </Col>
              </Row>
            </div> */}
          </Modal>
        )}
      </>
    );
  }
}
